import axios from 'axios';
import { useEffect, useState } from 'react';
import { introduccionDTO } from '../../models/Colecciones.model';
import { pathImages, webApiContenidoAcercaDe } from '../../routes/endpoints';


export default function Contenido(){

const [introduccion, setIntroduccion] = useState<introduccionDTO[]>();
useEffect(()=>{
    axios.get(webApiContenidoAcercaDe).then((response) => {
        setIntroduccion(response.data) 
    }).catch(err => console.warn(err));  
},[]);

    return(
        <>   
        { introduccion?.map( (intro, i) =>     
            <div className="container-fluid" key={intro.id}>
                <div className="row">
                    <div className="col-12 col-md-6 col-lg-5 p-4 text_collection_container d-inline-flex align-items-center">
                        <div dangerouslySetInnerHTML={{__html: `${intro.texto}` }}></div> 
                    </div>
                    <div className="col-12 col-md-6 col-lg-7 px-0 img_collection_container">
                        <div className="box_mask">
                            <img src={`${pathImages}${intro.imagen}`} alt="Imagen" />
                        </div>
                    </div>
                    
                </div>
            </div>  
            )
        }    
        </>
    )
}